import { IChartState } from '../../types/charts';
import { TReduxActions } from '../../types/redux';
import { filtersActionTypes, chartsActionTypes } from '../../constants/actionTypes';

const defaultState: IChartState = {
  prices: null,
  demand: null,
  supply: null,
  mortgage: null,
  loading: false,
};

export function chartsReducer(state: IChartState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case filtersActionTypes.SET_CHARTS_DATA:
      return {
        ...state,
        ...action.payload,
      };

    case chartsActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
